export function updateContextPagination(level, pagination, res, setContext, removeContext) {
    const needContextUpdate = ['attendees', 'orders'];
    if (!level || !needContextUpdate.includes(level)) {
        return null;
    }

    const totalCount = res?.__meta?.headers?.get('total-count');

    if (totalCount) {
        needContextUpdate
            .filter(c => c !== level)
            .forEach(context => {
                removeContext([`${context}ListCount`, `${context}ListPagination`]);
            });
    }
    const currentPage = pagination?.currentPage;
    const pageSize = pagination?.pageSize;
    const ordering = pagination?.ordering;
    const offset = pagination?.currentPage * pagination?.pageSize;

    const newContext = {};

    // only include count if total-count is present
    if (totalCount) {
        newContext[`${level}ListCount`] = parseInt(totalCount);
    }
    newContext[`${level}ListPagination`] = {
        currentPage,
        pageSize,
        ordering,
        offset
    };

    setContext(ctx => {
        return {
            ...ctx,
            ...newContext
        };
    });
}
